import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import type { DataSource } from '../models/cache.models';

/**
 * CacheStateService
 *
 * Tracks which data source the cache interceptor is currently serving from
 * (network, cache, or unknown). Used exclusively by the post-cache interceptor
 * to signal whether a response came from the network or from the local cache.
 *
 * For online/offline connectivity status, use NetworkService (@capacitor/network).
 */
@Injectable({
  providedIn: 'root',
})
export class CacheStateService {
  private readonly dataSourceSubject = new BehaviorSubject<DataSource>('unknown');

  /**
   * Set the current data source.
   * Called by the cache interceptor when serving from cache or network.
   */
  public setDataSource(source: DataSource): void {
    this.dataSourceSubject.next(source);
  }

  /**
   * Get current data source synchronously.
   */
  public getCurrentDataSource(): DataSource {
    return this.dataSourceSubject.value;
  }
}
